import type { ReactNode } from "react";
import { Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";

import type { CreateBlockReason } from "../useConnectionCreateRules";
import { useCreateBlockCopy } from "./useCreateBlockCopy";
import styles from "./ConnectionCreateBlocked.module.css";

/** Explains a disabled create action; disabled buttons ignore hover/focus, so a wrapper holds the tooltip. */
export function ConnectionCreateBlockedTooltip({
  reason,
  children,
}: {
  reason: CreateBlockReason;
  children: ReactNode;
}) {
  const { getMessage } = useCreateBlockCopy();

  return (
    <Tooltip content={getMessage(reason)} allowMultiline placement="top">
      <TooltipFocusableTrigger className={styles.disabledActionTrigger}>
        {children}
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}
